module.exports = __webpack_public_path__ + "img/step3.4e6a74d5.png";